const wayfindingPosters = [
  {
    id: '1',
    building: 'D and E',
    lat: 49.917951,
    lng: -97.213275,
  },
  {
    id: '2',
    building: 'E and F',
    lat: 49.91858,
    lng: -97.213278,
  },
  {
    id: '3',
    building: 'D',
    lat: 49.91782,
    lng: -97.21232,
  },
  {
    id: '4',
    building: 'C',
    lat: 49.917818,
    lng: -97.212099,
  },
  {
    id: '5',
    building: 'C',
    lat: 49.917797,
    lng: -97.21185,
  },
  {
    id: '6',
    building: 'D',
    lat: 49.918259,
    lng: -97.211841,
  },
  {
    id: '7',
    building: 'A',
    lat: 49.91792,
    lng: -97.211359,
  },
  {
    id: '8',
    building: 'A',
    lat: 49.91749,
    lng: -97.210344,
  },
  {
    id: '9',
    building: 'A',
    lat: 49.917995,
    lng: -97.210429,
  },
  {
    id: '10',
    building: 'T',
    lat: 49.917991,
    lng: -97.209055,
  },
  {
    id: '11',
    building: 'T',
    lat: 49.917988,
    lng: -97.207536,
  },
  {
    id: '12',
    building: 'T',
    lat: 49.918027,
    lng: -97.209247,
  },
  {
    id: '13',
    building: 'B',
    lat: 49.918625,
    lng: -97.209407,
  },
  {
    id: '14',
    building: 'B',
    lat: 49.918792,
    lng: -97.210337,
  },
  {
    id: '15',
    building: 'J',
    lat: 49.920052,
    lng: -97.21026,
  },
  {
    id: '16',
    building: 'M',
    lat: 49.919382,
    lng: -97.209374,
  },
  {
    id: '17',
    building: 'M',
    lat: 49.9204,
    lng: -97.209352,
  },
  {
    id: '18',
    building: 'Z',
    lat: 49.919632,
    lng: -97.20837,
  },
];

const wayfindingByID = (id) =>
  wayfindingPosters.find((wayfinding) => wayfinding.id === id);

export { wayfindingPosters, wayfindingByID };
